import React from 'react';

import { themeStyle } from '@repo/ui/theming';

import TextBlock from '../shared/TextBlock/TextBlock';

import { DescriptionSection } from './styles';
import { BannerProps } from './types';

type DescriptionProps = Pick<BannerProps, 'description'> & {
  alignCenter: boolean;
};

export const Description: React.FC<DescriptionProps> = ({
  description,
  alignCenter,
}) => {
  if (!description) {
    return null;
  }

  if (typeof description === 'string') {
    return (
      <DescriptionSection alignCenter={alignCenter}>
        {description}
      </DescriptionSection>
    );
  }

  return (
    <DescriptionSection alignCenter={alignCenter}>
      <TextBlock
        color={themeStyle.darkInkMedium}
        paragraphType="p0"
        text={description}
      />
    </DescriptionSection>
  );
};
